function StandardNarrations() {
    return (
        <div>
            <h2>Standard Narrations</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default StandardNarrations;